module.exports = __webpack_public_path__ + "static/media/tecnico.79bdd7c0.svg";